import * as Icons from '@ant-design/icons';

// opeq: This is a generic component that renders an icon based on the iconName prop, but maybe can lead to bigger size of the bundle? If so we could just import explictly by
// import {
//     DollarCircleOutlined,
//     // Import other icons as needed
//   } from '@ant-design/icons';
  
//   const iconMap = {
//     DollarCircleOutlined,
//     // Add other icon mappings here
//   };

// and use iconMap[iconName] instead of Icons[iconName] ?

const IconRenderer = ({ iconName, className }) => {
    const IconComponent = Icons[iconName];

    if (!IconComponent) {
        console.log('IconComponent nt found', iconName,  Icons, IconComponent);
        return <span>Icon not found</span>;
    }

    return <IconComponent className={className} />;
};

export default IconRenderer;